import AdminExpenseTypeDetails from './AdminExpenseTypeDetails';
import AdminExpenseTypes from './AdminExpenseTypes';


export {
    AdminExpenseTypes,
    AdminExpenseTypeDetails,
};

export default AdminExpenseTypes;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/ExpenseTypes/index.tsx